module.exports = __webpack_public_path__ + "img/badge_1.png";